module.exports = __webpack_public_path__ + "static/media/locked.94e12f57.svg";